/**
 * This class can capture/release the tabability of an area of the DOM.
 */
export default class TabIndexCapture {

    constructor(root) {
        this.root = root;
    }

    _preventFocus() {
        this._allowFocus();
        this._before = [];
        var me = this;
        this.root.find("input, select, textarea, button, object, a[href], *[tabindex]")
            .each(function(i, el) {
                me._before.push({
                    element: el,
                    tabindex: el.getAttribute("tabindex")
                });
                el.setAttribute("tabindex", "-1");
            });
    }

    _allowFocus() {
        if (this._before) {
            this._before.forEach(function(before) {
                if (before.tabindex === "-1" || before.tabindex === "0") {
                    before.element.setAttribute("tabindex", before.tabindex);
                } else {
                    before.element.removeAttribute("tabindex");
                }
            });
            delete this._before;
        }
    }

    capture() {
        this._preventFocus();
    }

    release () {
        this._allowFocus();
    }

}
